/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_CancelledInputs */

const vi_irrigation_run_cancelled = /** @type {(inputs: Irrigation_Run_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã huỷ phiên tưới`)
};

/**

* @param {Irrigation_Run_CancelledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_cancelled = /** @type {((inputs?: Irrigation_Run_CancelledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_CancelledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_cancelled(inputs)
});